<template lang="pug">
    div
        v-expansion-panels.mb-6(style="border-radius:10px")
            v-expansion-panel(v-for="(quest,index) in faq" :key="index")
                v-expansion-panel-header(expand-icon="mdi-chevron-down")
                    v-row
                        v-col.py-0(cols="1")
                            h3.title {{ index+1 }}.
                        v-col.py-0(cols="11")
                            h3.title {{ quest.question }}
                v-expansion-panel-content
                    v-row
                        v-col.py-0(cols="1")
                        v-col.py-0(cols="11")
                            p.deep--text {{ quest.answer }}
</template>
<script>
export default {
    props:['faq']
}
</script>